/**
 * The four semantic colours of the deal board, each as a Tailwind class
 * table — cards, rails, the stepper banner, the next-step card and the sheet
 * badge all pick from here, so an emerald/amber string never lives inline.
 */
export type Tone = 'emerald' | 'amber' | 'destructive' | 'muted';

export const TONE_TEXT: Record<Tone, string> = {
  emerald: 'text-emerald-700 dark:text-emerald-400',
  amber: 'text-amber-700 dark:text-amber-400',
  destructive: 'text-destructive',
  muted: 'text-muted-foreground',
};

/** Left accent stripe (`border-l-*`) of cards and callouts. */
export const TONE_BORDER_L: Record<Tone, string> = {
  emerald: 'border-l-emerald-500',
  amber: 'border-l-amber-500',
  destructive: 'border-l-destructive',
  muted: 'border-l-muted-foreground/40',
};

/** Full border of a tinted banner / badge. */
export const TONE_BORDER: Record<Tone, string> = {
  emerald: 'border-emerald-500/40',
  amber: 'border-amber-500/40',
  destructive: 'border-destructive/40',
  muted: 'border-muted-foreground/40',
};

export const TONE_BG: Record<Tone, string> = {
  emerald: 'bg-emerald-500/10',
  amber: 'bg-amber-500/10',
  destructive: 'bg-destructive/10',
  muted: 'bg-muted',
};

/** Drop-target highlight ring. */
export const TONE_RING: Record<Tone, string> = {
  emerald: 'ring-2 ring-emerald-500/60',
  amber: 'ring-2 ring-amber-500/60',
  destructive: 'ring-2 ring-destructive/60',
  muted: 'ring-2 ring-muted-foreground/40',
};
